import React from "react";
import { Link } from "react-router-dom";
import styles from "./styles.module.scss";

const Separator = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4"
    height="10"
    viewBox="0 0 4 10"
    fill="none"
  >
    <path d="M4 0L1.02786 10H0L2.97214 0H4Z" fill="#89888D" />
  </svg>
);

const Breadcrumbs = ({ items = [], className = "" }) => {
  return (
    <div className={`${styles.breadcrumbs} ${className}`}>
      {items.map((item, index) => (
        <React.Fragment key={item.label}>
          {index > 0 && <Separator />}
          {item.to ? (
            <Link to={item.to} className={styles.link}>
              <p>{item.label}</p>
            </Link>
          ) : (
            <p className={styles.nonLink}>{item.label}</p>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
